module.exports = __webpack_public_path__ + "static/img/17.35abce53.png";